import React, { useEffect } from 'react';
import { Button, Radio, Menu, MenuItem, Icon, Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './Announcement.module.scss';
import api from '../../api';

// import { Markdown } from '../../lib/custom-ui';
import AnnouncementModal from './AnnouncementModal';
import AnnouncementInfoModal from './AnnouncementInfoModal';
import Config from '../../constants/Config';
import DeletePopup from '../DeletePopup';
import moment from 'moment';

const Aonnouncement = React.memo(({}) => {
  const { search } = useLocation();
  const form = new URLSearchParams(search).get('form');
  const navigate = useNavigate();

  const [listObj, setListObj] = React.useState({
    list: [],
    total: 0,
  });
  const [currentSkip, setCurrrentSkip] = React.useState(1);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isCheckOpen, setIsCheckOpen] = React.useState(false);
  const [edit, setEdit] = React.useState({});

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleClose = () => {
    setIsOpen(false);
    setEdit({});
  };

  const handleCheckClose = () => {
    setIsCheckOpen(false);
    setEdit({});
  };
  const getList = React.useCallback(() => {
    if (form === 'admin') {
      api
        .getAnnouncementList({
          limit: Config.AONNOUCEMENT_LIMIT,
          skip: currentSkip - 1,
        })
        .then((res) => {
          setListObj({ list: res.item, total: res.total });
        });
    } else {
      api
        .getAnnouncementUserList({
          limit: Config.AONNOUCEMENT_LIMIT,
          skip: currentSkip - 1,
        })
        .then((res) => {
          setListObj({ list: res.item, total: res.total });
        });
    }
  }, [form, currentSkip]);

  const handleRelease = (data, checked) => {
    api
      .updateAnnouncement(data.id, {
        isRelease: checked,
      })
      .then((res) => {
        setListObj((pre) => {
          const newList = pre.list.map((item) => {
            if (item.id === data.id) {
              return res.item;
            }
            return item;
          });
          return {
            ...pre,
            list: newList,
          };
        });
      });
  };

  const handleDelete = async (data) => {
    await api.deleteAnnouncement(data.id);
    getList();
  };

  const handleCheck = (data) => {
    setIsCheckOpen(true);
    setEdit(data);
  };
  const handleEdit = (data) => {
    setEdit(data);
    setIsOpen(true);
  };

  useEffect(() => {
    setCurrrentSkip(1);
  }, [form]);
  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSkip, form]);

  return (
    <div className={styles.app}>
      {isCheckOpen && <AnnouncementInfoModal edit={edit} onClose={handleCheckClose} />}
      {isOpen && <AnnouncementModal edit={edit} onRenew={getList} onClose={handleClose} />}
      <div className={styles.table}>
        {form === 'admin' && (
          <Button
            positive
            content="新增公告"
            onClick={() => {
              setIsOpen(true);
            }}
          />
        )}
        {form === 'user' && <Button onClick={handleGoBack}>返回</Button>}
        <Table celled unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={form === 'admin' ? 4 : 10}>标题</Table.HeaderCell>
              <Table.HeaderCell>发布日期</Table.HeaderCell>
              {form === 'admin' && (
                <>
                  <Table.HeaderCell>更新日期</Table.HeaderCell>
                  <Table.HeaderCell>是否发布</Table.HeaderCell>
                  <Table.HeaderCell width={4}>操作</Table.HeaderCell>
                </>
              )}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {listObj.list.map((item) => (
              <Table.Row key={item.id}>
                <Table.Cell
                  className={styles.title}
                  onClick={() => {
                    handleCheck(item);
                  }}
                >
                  {item.title}
                </Table.Cell>
                <Table.Cell>{moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</Table.Cell>
                {form === 'admin' && (
                  <>
                    <Table.Cell>
                      {item.updatedAt && moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')}
                    </Table.Cell>
                    <Table.Cell>
                      <Radio
                        toggle
                        checked={item.isRelease}
                        onChange={(_, { checked }) => {
                          handleRelease(item, checked);
                        }}
                      />
                    </Table.Cell>
                  </>
                )}
                {form === 'admin' && (
                  <Table.Cell>
                    <button
                      type="button"
                      className={styles.action}
                      onClick={() => {
                        handleCheck(item);
                      }}
                    >
                      查看
                    </button>
                    <button
                      type="button"
                      className={styles.action}
                      onClick={() => {
                        handleEdit(item);
                      }}
                    >
                      编辑
                    </button>
                    <DeletePopup
                      title="提示"
                      content="您确定要删除此公告吗"
                      buttonContent="删除"
                      onConfirm={() => {
                        handleDelete(item);
                      }}
                    >
                      <button type="button" className={styles.action}>
                        删除
                      </button>
                    </DeletePopup>
                  </Table.Cell>
                )}
              </Table.Row>
            ))}
          </Table.Body>
          {!!listObj.list.length && (
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="5">
                  <Menu floated="right" pagination>
                    <MenuItem
                      as="a"
                      icon
                      onClick={() => {
                        setCurrrentSkip((pre) => {
                          if (pre <= 1) {
                            return 1;
                          }
                          return pre - 1;
                        });
                      }}
                    >
                      <Icon name="chevron left" />
                    </MenuItem>
                    {Array.from({ length: listObj.total }, (_, index) => (
                      <MenuItem
                        as="a"
                        key={index}
                        className={classNames(index + 1 === currentSkip && styles.menuItemActive)}
                        onClick={() => {
                          setCurrrentSkip(index + 1);
                        }}
                      >
                        {index + 1}
                      </MenuItem>
                    ))}
                    <MenuItem
                      as="a"
                      icon
                      onClick={() => {
                        setCurrrentSkip((pre) => {
                          if (pre + 1 >= listObj.total) {
                            return listObj.total;
                          }
                          return pre + 1;
                        });
                      }}
                    >
                      <Icon name="chevron right" />
                    </MenuItem>
                  </Menu>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          )}
        </Table>
        {!listObj.list.length && <div className={styles.empy}>暂无公告</div>}
      </div>
    </div>
  );
});

export default Aonnouncement;
